import React, { useState } from 'react';

import dynamic from 'next/dynamic';

import useSearchBar from '@components/views/hooks/useSearchBar';
import { LocationAnimationErrorBox } from '@components/views/components/listing/ListingStyle';
import { usePageTransitionAnimation } from '@hooks/animations';
import { useDevice } from '@contexts/device';
import Typography from '@components/Typography';

import {
  Content,
  Footer,
  SearchShipWrapper,
  StyledButton,
  StyledSimpleButton,
} from './styled';

const Modal = dynamic(() => import('@components/Modal/next/Modal'));
const DestinationSearch = dynamic(
  () =>
    import('@components/views/components/DestinationSearch/DestinationSearch')
);
const MobileSearchBar = dynamic(
  () => import('@components/views/tour/components/SearchBar/MobileSearchBar')
);

interface ShipSearchFormProps {
  onCancel?(): void;
  onSubmit?(): void;
  setShowLoader?: (value: boolean) => void;
}

const ShipSearchForm = ({ onCancel, setShowLoader }: ShipSearchFormProps) => {
  const { isDesktop } = useDevice();

  const {
    errors,
    handleSubmit,
    destination,
    destinationSearchText,
    onDestinationTextChange,
    onDestinationChange,
  } = useSearchBar('ship');
  const { isLoading } = usePageTransitionAnimation();
  const [destinationError, setDestinationError] = useState(false);
  const onSearch = () => {
    if (destination === undefined) {
      setDestinationError(true);
    }
    setShowLoader?.(true);
    destination &&
      destination.url &&
      window.open(`/${destination.url}`, '_self');
  };

  return isDesktop ? (
    <Modal
      title={
        <Typography variant='Title4' weight='SemiBold' color='D400'>
          Gemi Ekleyin
        </Typography>
      }
      backgroundColor='lynxWhite'
      onCancel={onCancel}
      width={774}
      zIndex={98}
      borderRadius={8}
    >
      <form onSubmit={handleSubmit(onSearch)}>
        <Content>
          <LocationAnimationErrorBox
            borderRadius='8px'
            hasError={!!errors.destination || destinationError}
          >
            <SearchShipWrapper>
              <DestinationSearch
                placeholder='Ülke, şehir, bölge, liman veya tur adı'
                onDestinationChange={onDestinationChange}
                searchText={destinationSearchText}
                onSearchTextChange={onDestinationTextChange}
                type='ship'
                borderRadius='8px'
              />
            </SearchShipWrapper>
          </LocationAnimationErrorBox>
        </Content>
        <Footer>
          <StyledSimpleButton onClick={onCancel}>Vazgeç</StyledSimpleButton>
          <StyledButton
            type='submit'
            disabled={isLoading}
            loading={isLoading}
            variant='Primary'
          >
            Turları Listele
          </StyledButton>
        </Footer>
      </form>
    </Modal>
  ) : (
    <MobileSearchBar
      setIsRedirecting={setShowLoader}
      destination={destination}
      onDestinationChange={onDestinationChange}
      tourListCount={0}
      type='ship'
      defaultIsModalVisible={true}
      isSearchResultHeaderVisible={false}
      searchButtonTitle='Turları Listele'
      title={
        <Typography variant='Title4' weight='SemiBold' color='D400'>
          Gemi Ekleyin
        </Typography>
      }
      onCancel={onCancel}
    />
  );
};

export default ShipSearchForm;
